import { createSlice } from "@reduxjs/toolkit";
import { IFavorite } from "../types/Favorites/IFavorite";

const FavoriteSlice = createSlice({
  name: "revelation",
  initialState: {
    favorites: [] as IFavorite[],
  },
  reducers: {
    saveFavorites: (state, action) => {
      //console.log('saveFavorites', action.payload)
      state.favorites = action.payload;
    },
  },
});

export const { saveFavorites } = FavoriteSlice.actions;
export default FavoriteSlice.reducer;
